import './skeleton.css'

/**
 * A loading placeholder — the design system's **ledger shimmer**, its default
 * treatment "for any list or table whose shape is known". Issue 253.
 *
 * Decoration only — `aria-hidden`, because a screen reader announcing a row of
 * grey bars is noise. `<Async>` wraps the loading state in a live region so the
 * state itself is still announced.
 *
 * **It was a 1.4s opacity pulse until 2026-08-13**, and the change is a ruling
 * rather than a preference. Two design sources disagreed: §Motion said
 * "skeleton pulse 1.4s" and the Loading & progress section said shimmer. The
 * contradiction was removed at source — §Motion now defers with "Loading
 * indicators carry their own timing" — so the shimmer is the surviving
 * specification, and `@keyframes pulse` went with the last thing that used it.
 *
 * The sweep is a child rather than a background on the bar itself, which is how
 * the design draws it: the bar is opaque `--track` and the highlight travels
 * over it. Animating a background-position instead would have been one element,
 * and would not survive the bar being given content later.
 *
 * One thing the design does that this does not: its sample staggers adjacent
 * rows with `animation-delay: .14s`. That is in the comp only — no prose or
 * table states it as a rule — and it would cost a prop that three call sites
 * would have to thread an index through. Left out deliberately, not missed.
 */
export function Skeleton({
  height = 16,
  width = '100%',
}: {
  height?: number
  width?: number | string
}) {
  return (
    <div className="skeleton" aria-hidden style={{ height, width }}>
      {/* `.shimmer` is motion.css's — the travel and its 1.9s linear timing —
          and is what `prefers-reduced-motion` switches off. `.skeleton__sweep`
          is the static geometry and gradient. The split is M0-R20's: motion
          lives in one file, and motion.test.ts fails any other sheet that
          animates. */}
      <span className="skeleton__sweep shimmer" />
    </div>
  )
}
